import { Icon, IconProps } from "../Icon";

const LaunchOpenInNew = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 28H6C4.89543 28 4 27.1046 4 26V6C4 4.89543 4.89543 4 6 4H15V6H6V26H26V17H28V26C28 27.1046 27.1046 28 26 28ZM21 2V4H26.59L18 12.59L19.41 14L28 5.41V11H30V2H21Z"
      fill="currentColor"
    />
  </Icon>
);

export default LaunchOpenInNew;
